export default __webpack_public_path__ + "static/media/PaydayLoanAgreement_AB.147a5194.pdf";